
import React, { useRef, useState } from "react";
// Import Swiper React components
import { Swiper, SwiperSlide } from "swiper/react";
import Review from "../Review"
// Import Swiper styles
import "swiper/css";
import "swiper/css/navigation";

import "./testimonial.css";
import {TESTIMONIALS} from "../../constant"
// import required modules
import { Navigation } from "swiper";

const Testimonials=()=> {
  return (
    <>
      <Swiper navigation={true} modules={[Navigation]}
       className="mySwiper"
         style={{
          "--swiper-navigation-color": "#d2a960",
          "--swiper-pagination-color": "#d2a960"}}
        grabCursor={true}
        centeredSlides={true}
        loop={true}
        pagination={{
          clickable: true,
        }}>
        
        {TESTIMONIALS.map((test,i)=>{
            return(
        <SwiperSlide className="bg-black" key={i}><Review content={test.content} title={test.title} subtitle={test.subtitle}/></SwiperSlide>
            )})}
      
      </Swiper>
    </>
  );
}


export default Testimonials